module.exports = __webpack_public_path__ + "img/blankscreen_300.86cb5eaa.jpg";